export default "__VITE_ASSET__BsHmXQw8__"